import { render, staticRenderFns } from "./VNumberInput.vue?vue&type=template&id=5e519251&"
import script from "./VNumberInput.vue?vue&type=script&lang=ts&"
export * from "./VNumberInput.vue?vue&type=script&lang=ts&"
import style0 from "./VNumberInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports